import { useEffect } from 'react';
const SCRIPT_SRC = 'https://widgets.leadconnectorhq.com/loader.js';
const WIDGET_ID = '6a83704e43b7e14560da52e9';

/**
 * Injects the GoHighLevel (LeadConnector) chat widget loader into the document
 * body, exactly as required by the GHL Trust Center website-compliance check.
 * Renders no markup of its own — the widget mounts itself.
 */
export function LeadConnectorWidget() {
  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', WIDGET_ID);
    script.setAttribute('data-source', 'WEB_USER');
    document.body.appendChild(script);
  }, []);
  return null;
}